import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import useFirebase from '../../../hooks/useFirebase';
import './Navigation.css'

const Navigation = () => {
    const { user, logout } = useFirebase();
    // NavBar Style
    const navLinkStyle = {
        textDecoration: "none",
        color: "black",
        margin: "10px",
        padding: "10px 0",
        fontSize: "1.2rem",
        fontWeight: "bold"
    };
    return (
        <div className="sticky-navbar">
            <nav className="navbar ">
                <div className="d-flex container-fluid">
                    <div className="ms-5 text-uppercase d-flex">
                        <i className="fas fa-book-reader ps-4 pe-2"></i>

                        {/* Logo  */}
                        <Link to="/" className="text-decoration-none color-1 logo-link text-sm-center">
                            <h3 className="logo">
                                Language<span className="color-1 logo"> Buddy</span>
                            </h3>
                        </Link>
                    </div>
                    {/* Navigation Child  */}
                    <div className=" pe-3 d-md-flex navbar-links">
                        <NavLink style={navLinkStyle} to="/home">
                            Home
                        </NavLink>
                        <NavLink style={navLinkStyle} to="/explore">
                            Start Learning
                        </NavLink>
                        <NavLink style={navLinkStyle} to="/blogs">
                            Blog
                        </NavLink>
                        <NavLink style={navLinkStyle} to="/about">
                            About Us
                        </NavLink>
                        <NavLink style={navLinkStyle} to="/contact">
                            Contact Us
                        </NavLink>

                        {/* Conditional Button  */}
                        <div className="mt-2 conditional-button">
                            {user?.email || user?.displayName ? (
                                <div className="d-flex">

                                    {/* Dropdown Button  */}
                                    <div className="dropdown">
                                        <button
                                            className="secondary-button me-2 mt-1 text-capitalize"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            {user.displayName} <i className="fas fa-sort-down"></i>
                                        </button>
                                        <div
                                            className="dropdown-menu bg-1 box-shadow"
                                            aria-labelledby="dropdownMenuButton1"
                                        >
                                            <div>
                                                <Link className="dropdown-item" to="/dashboard">
                                                    My Profile
                                                </Link>
                                            </div>
                                            {/* <div>
                                                <Link className="dropdown-item" to="/my-courses">
                                                    My Courses
                                                </Link>
                                            </div>
                                            <div>
                                                <Link className="dropdown-item" to="/manage-courses">
                                                    Manage Courses
                                                </Link>
                                            </div>
                                            <div>
                                                <Link className="dropdown-item" to="/add-course">
                                                    Add a New Course
                                                </Link>
                                            </div>
                                            <hr className="dropdown-divider" />
                                            <div>
                                                <Link
                                                    onClick={logout}
                                                    className="dropdown-item"
                                                >
                                                    Log Out
                                                </Link>
                                            </div> */}
                                        </div>
                                    </div>

                                    {/* Logout and Login  */}
                                    <button
                                        onClick={logout}
                                        className="primary-button ms-0 transition"
                                    >
                                        <i className="fas fa-unlock"></i> LogOut
                                    </button>
                                </div>
                            ) : (
                                <div>
                                    <NavLink to="/login">
                                        <button className="primary-button transition">
                                            <i className="fas fa-lock"></i> Login
                                        </button>
                                    </NavLink>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navigation;


